import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { RavelEmoji } from '../../../../../modules/RavelEmoji.js';

export class RavelSequence extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #container {
            position: absolute;
        }
        .cell {
            display: inline-block;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container"></div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'cells', 'icon-active', 'icon-inactive', 'size', 'x', 'y', 'orientation', 'sequence-id', 'period'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#container');
        this.iconActive = RavelEmoji.getRandomEmoji();
        this.iconInactive = RavelEmoji.getRandomEmoji();
        this.period = 400;
        this.shuttle = 0;
    }
  
    setup = () => {
        this.observedMessages = ['message'];
        //this.subscribe(this.observedMessages);   
        this.cellList = [];
        this.container.innerHTML = '';
        for (let i = 0; i < this.cells; i++) {
            this.cellList.push(this.iconInactive);
            this.container.innerHTML += `<div class="cell" id="cell-${i}">${this.iconInactive}</div>`;
        }
        this.setFontSize();
        this.timer = setInterval(
            () => {
                if (this.shuttle > this.cells) this.shuttle = 0;
                this.shadowRoot.querySelector(`#cell-${this.shuttle}`).innerText = this.iconInactive;
                this.shuttle = (this.shuttle + 1) % this.cells;
                this.shadowRoot.querySelector(`#cell-${this.shuttle}`).innerText = this.iconActive;
            },
            this.period
        );
    }
    
    teardown = () => {
       // this.unsubscribe(this.observedMessages);
    }
    
    setFontSize() {
        let size = this.size * 20;
        let newSize = size / this.cells;
        console.log(this.size);
        console.log(this.cells);
        console.log(newSize);
        if (newSize > 100) newSize = 100;
        this.container.style['font-size'] = `${newSize}px`;
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        
        if (name === 'icon-active') {
            this.iconActive = newValue;
        }
        if (name === 'icon-inactive') {
            this.iconInactive = newValue;
        }
        if (name === 'cells') {
            this.cells = parseInt(newValue, 10);
            this.cellList = [];
            this.container.innerHTML = '';
            for (let i = 0; i < this.cells; i++) {
                this.cellList.push(this.iconInactive);
                this.container.innerHTML += `<div class="cell" id="cell-${i}">${this.iconInactive}</div>`;
            }
            if (this.shuttle > this.cells) this.shuttle = 0;
            if (this.size) this.setFontSize();
        }
        if (name === 'size') {
            this.size = parseInt(newValue, 10);
        }
        if (name === 'x') {
            this.container.style.position = 'fixed';
            this.x = newValue;
            this.container.style.left = newValue;
        }
        if (name === 'y') {
            this.container.style.position = 'fixed';
            this.y = newValue;
            this.container.style.top = newValue;
        }
        if (name === 'orientation') {
            this.orientation = newValue;
        }
        if (name === 'sequence-id') {
            this.sliderId = newValue;
        }
    }
}
